import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Collection from "./Collection";
import FacetSidebar from "./FacetSidebar";
import Navigation from "./Navigation";
import CatalogItem from "./Item";
import { EventsWidget } from "./../EventsWidget/Widget";
import LoadingMask from "../Components/LoadingMask";
import Util from "../../../util";
import window from "global/window";
import ResizeContext from "./../Contexts/ResizeContext";
import DFP from "../Components/DFP/DFP";

class Catalog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasMounted: false,
            displaying: props.displaying,
            currentPage: props.currentPage || 1,
            maxPage: props.maxPage || 1,
            pageSize: props.pageSize || 24,
            facetCounts: props.facetCounts,
            sortBy: props.sortBy || "",
            items: props.products || [],
            filter: props.filter,
            isLoading: false,
            view: "grid",
            featuredCategory: props.featuredCategory,
            isMobile: false
        };
        this.fetchItems = this.fetchItems.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
        this.resetFieldFilter = this.resetFieldFilter.bind(this);
        this.resetPage = this.resetPage.bind(this);
        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.refreshAds = this.refreshAds.bind(this);
        this.pushDataLayer = this.pushDataLayer.bind(this);
    }

    componentDidMount() {
        this.setState(
            {
                hasMounted: true,
                view: this.props.view
            },
            () => {
                window.addEventListener("resize", this.handleWindowResize);
                this.handleWindowResize();
            }
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.currentPage != prevState.currentPage ||
            this.state.pageSize != prevState.pageSize ||
            this.state.sortBy != prevState.sortBy
        ) {
            this.fetchItems();
        }
    }

    fetchItems() {
        this.setState(
            {
                isLoading: true
            },
            () => {
                let filters = {};
                let currentParams =
                    window && window.location && window.location.search
                        ? window.location.search
                        : "";

                Object.entries(this.state.filter).forEach(([key, filter]) => {
                    let [queryKey] = key.split("_");
                    let queryFilter = filter;

                    if (queryKey == "price") {
                        queryFilter = queryFilter.replace("[", "");
                        queryFilter = queryFilter.replace("]", "");
                        queryFilter = queryFilter.replace(" TO ", ",");
                    }

                    if (!this.props.initialFilter[key]) {
                        if (currentParams.includes(queryKey)) {
                            currentParams = currentParams.replace(
                                new RegExp(`&${queryKey}=[a-zA-Z0-9,]+`, "i"),
                                queryFilter ? `&${queryKey}=${queryFilter}` : ""
                            );
                        } else if (queryFilter) {
                            currentParams += `&${queryKey}=${queryFilter}`;
                        }
                    }

                    switch (key) {
                        case "manufacturer_id_and_name":
                            key = "manufacturer_facet";
                            break;
                        case "category_id_and_name":
                            key = "category_ids";
                            break;
                        case "condition_id_and_name":
                            key = "condition_facet";
                            break;
                    }

                    // if filter is a comma delimited string, convert to an array for next steps
                    if (typeof filter === "string" && filter.includes(",")) {
                        filter = filter.split(",");
                    }

                    // Prep Filters for solr api request
                    if (filter && !Array.isArray(filter)) {
                        filters[key] = encodeURIComponent(filter);
                    } else if (filter && filter.length > 0) {
                        filters[key] = `(${filter.join(" OR ")})`;
                    }
                });

                filters = JSON.stringify(filters);

                filters = filters.replace("&", "%26");

                axios
                    .get(
                        `/api/solr?currentPage=${
                            this.state.currentPage
                        }&pageSize=${this.state.pageSize}&search=${
                            this.props.query
                        }&sort=${
                            this.state.sortBy
                        }&filters=${filters}&facetFields=${JSON.stringify(
                            this.props.facetFields
                        )}&handler=${this.props.handler}`
                    )
                    .then(_result => {
                        let result = _result.data.response;
                        let facetCounts = _result.data.facet_counts;

                        Object.entries(facetCounts.facet_fields).forEach(
                            ([facetField, facetValue]) => {
                                if (
                                    this.state.filter[facetField] &&
                                    this.state.filter[facetField].length > 0
                                ) {
                                    facetCounts.facet_fields[
                                        facetField
                                    ] = this.state.facetCounts.facet_fields[
                                        facetField
                                    ];
                                } else {
                                    facetCounts.facet_fields[
                                        facetField
                                    ] = Util.convertSolrFacetArrayToObject(
                                        facetValue
                                    );
                                }
                            }
                        );

                        const maxPage = Math.ceil(
                            Number(result.total) / Number(result.pageSize)
                        );

                        let displaying =
                            Number(result.total) > 0
                                ? `Showing ${Number(result.start) +
                                      1} - ${Number(result.start) +
                                      Number(result.result.length)} of ${
                                    result.total
                                } Items`
                                : "Showing 0 Items";

                        history.pushState(
                            { page: currentParams },
                            `new filter ${currentParams}`,
                            currentParams
                        );

                        this.setState(
                            {
                                items: result.result,
                                facetCounts: facetCounts,
                                pageSize: result.pageSize,
                                currentPage: result.start,
                                maxPage: maxPage,
                                displaying: displaying,
                                isLoading: false
                            },
                            () => this.pushDataLayer()
                        );
                    })
                    .catch(error => {
                        this.setState({
                            isLoading: false
                        });
                        console.error(error);
                    });
            }
        );
    }

    handleWindowResize() {
        if (!this.state.isMobile && window.innerWidth <= 576) {
            this.setState({ isMobile: true }, () => this.refreshAds("mobile"));
        } else if (this.state.isMobile && window.innerWidth > 576) {
            this.refreshAds("desktop");
            this.setState({ isMobile: false });
        }
    }

    refreshAds(viewState) {
        const mountDesktop = document.getElementById("mount-desktop");
        const mountMobile = document.getElementById("mount-mobile");
        const to = viewState === "mobile" ? mountMobile : mountDesktop;
        const from = to === mountDesktop ? mountMobile : mountDesktop;

        if (from && from.children.length > 0 && to) {
            to.appendChild(from.children[0]);
            while (from.firstChild) {
                from.removeChild(from.firstChild);
            }
            window.googletag
                .pubads()
                .refresh(null, { changeCorrelator: false });
        }
    }

    pushDataLayer() {
        const { ecommerce } = window.dataLayer[0];

        if (!ecommerce) return;

        const { currentPage, items } = this.state;

        let pushEvent = {
            ecommerce: {
                currencyCode: ecommerce.currencyCode,
                impressions: items.map(
                    (
                        {
                            name,
                            sku,
                            price,
                            manufacturer_name,
                            seller_id,
                            category_names
                        },
                        index
                    ) => ({
                        name: name,
                        id: sku,
                        price: price || "undefined",
                        brand: manufacturer_name,
                        variant: seller_id,
                        category: category_names
                            ? category_names[0]
                            : "no categories",
                        list: "category",
                        position: currentPage + (index + 1)
                    })
                )
            }
        };

        window.dataLayer.push(pushEvent);
    }

    render() {
        let date = new Date();
        let currentDate = `${date.getFullYear()}-${date.getMonth() +
            1}-${date.getDate()}`;
        let currentPage = this.props.currentPage;

        if (this.state.currentPage >= this.state.pageSize) {
            currentPage = Math.ceil(
                this.state.currentPage / this.state.pageSize + 1
            );
        } else {
            currentPage = 1;
        }

        return (
            <ResizeContext.Provider
                value={{
                    isMobile: this.state.isMobile
                }}>
                <div className="container-fluid">
                    <div className="row">
                        <LoadingMask isLoading={this.state.isLoading} />
                        <div className="col-12 col-sm-5 col-lg-3 sidebarFilters">
                            <FacetSidebar
                                title="Refine By..."
                                facetCounts={this.state.facetCounts}
                                initiallySelectedOptions={this.state.filter}
                                returnSelectedOptions={this.handleFilter}
                                resetSelectedOptions={this.resetFilter}
                                resetSelectedFieldOptions={
                                    this.resetFieldFilter
                                }
                                applyFilters={this.fetchItems}>
                                {this.props.showAds && (
                                    <div className="text-left">
                                        {this.state.hasMounted &&
                                            this.props.dfpArray.map(ad => (
                                                <DFP
                                                    key={ad.id}
                                                    id={ad.id}
                                                    className={ad.className}
                                                />
                                            ))}
                                    </div>
                                )}
                                {this.props.showEvents && (
                                    <div className="sidebar auctions">
                                        <EventsWidget
                                            title={"Upcoming Auctions"}
                                            pageSize={2}
                                            pageCount={1}
                                            filterGroups={[
                                                {
                                                    field: "categories",
                                                    value: "2",
                                                    condition: "finset"
                                                },
                                                {
                                                    field: "start_date_time",
                                                    value: `${currentDate}`,
                                                    condition: "lteq"
                                                },
                                                {
                                                    field: "end_date_time",
                                                    value: `${currentDate}`,
                                                    condition: "gteq"
                                                }
                                            ]}
                                            sortOrders={[
                                                {
                                                    field: "start_date_time",
                                                    direction: "desc"
                                                }
                                            ]}
                                        />
                                    </div>
                                )}
                                <div
                                    className="sideBarContent my-3"
                                    dangerouslySetInnerHTML={
                                        this.props.sideBarContent
                                    }
                                />
                            </FacetSidebar>
                        </div>
                        <div className="col-12 col-lg-9 col-md-12">
                            {this.props.query !== "*:*" ? (
                                <h2 className="title h1-clone">
                                    {this.state.displaying} for{" "}
                                    <span>{this.props.title}</span>
                                </h2>
                            ) : (
                                <h2 className="title h1-clone">
                                    {this.state.displaying}
                                </h2>
                            )}

                            <div className="catalog">
                                <Navigation
                                    currentPage={Number(currentPage)}
                                    maxPage={Number(this.state.maxPage)}
                                    pageSize={Number(this.state.pageSize)}
                                    view={this.state.view}
                                    pushHistoryOnChange={
                                        this.props.pushHistoryOnChange
                                    }
                                    pageSizeUrlPrefix={
                                        this.props.pageSizeUrlPrefix
                                    }
                                    currentPageUrlPrefix={
                                        this.props.currentPageUrlPrefix
                                    }
                                    sortByOptions={this.props.sortByOptions}
                                    pageSizeOptions={["24", "32", "64", "96"]}
                                    goTo={newPage => {
                                        this.setState({
                                            currentPage:
                                                (newPage - 1) *
                                                this.state.pageSize
                                        });
                                    }}
                                    changePageSize={newPageSize => {
                                        this.setState({
                                            pageSize: newPageSize
                                        });
                                    }}
                                    changeSortBy={newSortBy => {
                                        this.setState({ sortBy: newSortBy });
                                    }}
                                    changeView={newView => {
                                        this.setState({ view: newView });
                                    }}
                                    showView={!this.state.isMobile}
                                />
                                <Collection
                                    data={this.state.items}
                                    itemComponent={CatalogItem}
                                    restUrl={this.props.restUrl}
                                    isLoading={this.state.isLoading}
                                    view={this.state.view}
                                    className={`product-${this.state.view}`}
                                    dfpMidAd={
                                        this.state.isMobile &&
                                        this.props.dfpMidAd
                                    }
                                />
                                {this.state.items.length > 0 && (
                                    <Navigation
                                        currentPage={Number(currentPage)}
                                        maxPage={Number(this.state.maxPage)}
                                        pageSize={Number(this.state.pageSize)}
                                        view={this.state.view}
                                        pushHistoryOnChange={
                                            this.props.pushHistoryOnChange
                                        }
                                        pageSizeUrlPrefix={
                                            this.props.pageSizeUrlPrefix
                                        }
                                        currentPageUrlPrefix={
                                            this.props.currentPageUrlPrefix
                                        }
                                        pageSizeOptions={[
                                            "24",
                                            "32",
                                            "64",
                                            "96"
                                        ]}
                                        goTo={newPage => {
                                            this.setState({
                                                currentPage:
                                                    (newPage - 1) *
                                                    this.state.pageSize
                                            });
                                        }}
                                        changePageSize={newPageSize => {
                                            this.setState({
                                                pageSize: newPageSize
                                            });
                                        }}
                                        changeSortBy={newSortBy => {
                                            this.setState({
                                                sortBy: newSortBy
                                            });
                                        }}
                                        changeView={newView => {
                                            this.setState({ view: newView });
                                        }}
                                        showView={!this.state.isMobile}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </ResizeContext.Provider>
        );
    }

    handleFilter(selected, field) {
        let newFilter = Object.assign({}, this.state.filter);

        if (selected.hasOwnProperty("range")) {
            newFilter[field] = `[${selected.range[0]} TO ${selected.range[1]}]`;
        } else {
            if (selected.length > 0) {
                selected.forEach((option, index) => {
                    let { value } = option;

                    if (field == "category_id_and_name") {
                        value = value.split("_")[0];
                    } else if (field == "condition_id_and_name") {
                        value = value.split("_")[0];
                    } else if (field == "manufacturer_id_and_name") {
                        value = value.split("_")[0];
                    }

                    // Clear Array at the start
                    if (index == 0) {
                        newFilter[field] = [];
                    }

                    newFilter[field].push(value);
                });
            } else {
                newFilter[field] = undefined;
            }
        }

        this.resetPage();

        this.setState(
            {
                filter: newFilter,
                currentPage: 0
            },
            this.fetchItems()
        );
    }

    resetFilter() {
        this.resetPage();

        let currentParams = window.location.search;

        if (currentParams.includes("category")) {
            currentParams = currentParams.replace(
                new RegExp(`&category=[a-zA-Z0-9,]+`, "i"),
                ""
            );
        }
        if (currentParams.includes("condition")) {
            currentParams = currentParams.replace(
                new RegExp(`&condition=[a-zA-Z0-9,]+`, "i"),
                ""
            );
        }
        if (currentParams.includes("manufacturer")) {
            currentParams = currentParams.replace(
                new RegExp(`&manufacturer=[a-zA-Z0-9,]+`, "i"),
                ""
            );
        }
        if (currentParams.includes("price")) {
            currentParams = currentParams.replace(
                new RegExp(`&price=[a-zA-Z0-9,]+`, "i"),
                ""
            );
        }
        if (currentParams.includes("quote")) {
            currentParams = currentParams.replace(
                new RegExp(`&quote=[a-zA-Z0-9,]+`, "i"),
                ""
            );
        }

        history.replaceState(
            { page: 1 },
            `reset filters ${currentParams}`,
            currentParams
        );

        this.setState(
            {
                filter: Object.assign({}, this.props.initialFilter),
                currentPage: 0
            },
            this.fetchItems()
        );
    }
    resetFieldFilter(fieldKey) {
        let filterState = Object.assign({}, this.state.filter);

        filterState[fieldKey] = undefined;

        this.setState(
            {
                filter: filterState,
                currentPage: 0
            },
            this.fetchItems()
        );
    }
    resetPage() {
        let { currentPageUrlPrefix, pageSizeUrlPrefix, pageSize } = this.props;

        let currentParams = window.location.search;

        if (
            currentPageUrlPrefix.includes("?") ||
            pageSizeUrlPrefix.includes("?")
        ) {
            currentParams = currentParams.replace(
                new RegExp(`\\${currentPageUrlPrefix}[a-zA-Z0-9]+`, "i"),
                ""
            );
            currentParams = currentParams.replace(
                new RegExp(`\\${pageSizeUrlPrefix}[a-zA-Z0-9]+`, "i"),
                ""
            );
            currentParams = currentParams.replace("?", "&");
        }

        const href = `${currentPageUrlPrefix}${1}${pageSizeUrlPrefix}${pageSize}${currentParams}`;

        history.pushState({ page: 1 }, `page ${1}`, href);
    }
}

Catalog.defaultProps = {
    query: "*:*",
    filter: {},
    facetFields: [],
    showFeaturedCategory: true,
    additionalContent: "",
    showAds: true,
    showEvents: true,
    showTopProducts: true,
    dfpArray: [],
    pushHistoryOnChange: true,
    currentPageUrlPrefix: "?currentPage=",
    pageSizeUrlPrefix: "&pageSize=",
    sortBy: "",
    sortByOptions: [
        {
            label: "Default",
            value: ""
        },
        {
            label: "Most Recent",
            value: "created_at desc"
        },
        {
            label: "Price: High to Low",
            value: "price desc"
        },
        {
            label: "Price: Low to High",
            value: "price asc"
        }
    ],
    sideBarContent: { __html: "" },
    handler: "select",
    restUrl: process.env.REST_URL
        ? process.env.REST_URL
        : localStorage.getItem("restUrl"),
    dfpMidAd: false
};

Catalog.propTypes = {
    title: PropTypes.string,
    displaying: PropTypes.string,
    products: PropTypes.array.isRequired,
    facetCounts: PropTypes.object,
    facetFields: PropTypes.array,
    currentPage: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired
    ]),
    maxPage: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired
    ]),
    pageSize: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired
    ]),
    sortBy: PropTypes.string,
    sortByOptions: PropTypes.array,
    query: PropTypes.string,
    filter: PropTypes.object,
    pushHistoryOnChange: PropTypes.bool,
    currentPageUrlPrefix: PropTypes.string,
    pageSizeUrlPrefix: PropTypes.string,
    initialFilter: PropTypes.object,
    showFeaturedCategory: PropTypes.bool,
    featuredCategory: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    showAds: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    dfpArray: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            className: PropTypes.string
        })
    ),
    showEvents: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    showTopProducts: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    sideBarContent: PropTypes.any,
    handler: PropTypes.string,
    dfpMidAd: PropTypes.bool,
    view: PropTypes.string,
    restUrl: PropTypes.string
};

export { Catalog };
